module.exports = __webpack_public_path__ + "img/team-member-1.dd39e228.jpg";